import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

interface IProps {
  open: boolean;
  onConfirm: () => any;
}

export const AutoGeneratedDialog = React.memo(({ open, onConfirm }: IProps) => {
  return (
    <Dialog
      open={open}
      onClose={onConfirm}
      aria-labelledby="autogen-rule-dialog-title"
      aria-describedby="autogen-rule-dialog-description"
    >
      <DialogTitle id="autogen-rule-dialog-title">⚠️&nbsp; Auto-generated rule</DialogTitle>
      <DialogContent>
        <DialogContentText id="autogen-rule-dialog-description">
          This rule is auto-generated. It is not created and can not be edited with the Rule Editor.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
});
